/**
 * SDCX Fn 层虚拟键盘展示：
 * - 有 Fn 功能映射的格：显示功能名/图标码
 * - 无映射的格：回退普通层物理键帽
 */

import {
  isSdcxFnDisplayKeyCode as isSharedSdcxFnDisplayKeyCode,
  isSdcxFnLayerSupported,
} from "@eweadn-qiankun/shared-utils";

export type SdcxSdkRowLayout = {
  layer: number;
  row: number;
  keyboardLayout: number[];
};

/** Fn 层功能键 / 灯光 / 控制图标码（Type=0x1f 解码结果） */
export function isSdcxFnDisplayKeyCode(keyCode: number): boolean {
  return isSharedSdcxFnDisplayKeyCode(keyCode);
}

/** Fn 层行数据与普通层合并，空槽或未改键格保留基础层键名 */
export function applySdcxFnLayerToSdkRows(
  fnRows: SdcxSdkRowLayout[],
  baseRows?: SdcxSdkRowLayout[] | null
): SdcxSdkRowLayout[] {
  if (!baseRows?.length) return fnRows;
  return fnRows.map((fnRow) => {
    const baseRow = baseRows.find((item) => item.row === fnRow.row);
    if (!baseRow?.keyboardLayout?.length) return fnRow;
    const merged = fnRow.keyboardLayout.map((fnCode, col) => {
      const baseCode = baseRow.keyboardLayout[col] ?? 0;
      if (!fnCode) return baseCode;
      if (isSdcxFnDisplayKeyCode(fnCode)) return fnCode;
      if (fnCode === baseCode) return baseCode;
      return fnCode;
    });
    return { ...fnRow, keyboardLayout: merged };
  });
}

export function shouldApplySdcxFnLayer(
  keyboardType: string,
  layer: number,
  solutionRovider?: string | null
): boolean {
  return (
    layer !== 0 &&
    isSdcxFnLayerSupported(keyboardType) &&
    String(solutionRovider ?? "") === "SDCX"
  );
}
